export enum MediaEventType {
  STOP_ALL_VIDEOS = 'stop_all_videos',
  STOP_ALL_AUDIOS = 'stop_all_audios',
  STOP_ALL_RECORDINGS = 'stop_all_recordings',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/media-event.enum.ts